import axios from "axios";
import authHeader from "./auth-header";
import { checkEnvType } from "src/helper";
import { setMessage } from "src/slices/message";
import store from '../store'

const isDevelopment = checkEnvType();
const API_URL = isDevelopment
  ? process.env.REACT_APP_API_DEV_URL
  : process.env.REACT_APP_API_PROD_URL;


const instance = axios.create({
  baseURL: API_URL,
});
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    const message = (error.response && error.response.data && error.response.data.message) ||
      error.message || error.toString();
    store.dispatch(setMessage({ message, isError: true }));
    return Promise.reject(error);
  }
);

const addFashion = async (
  title,
  url,
  category,
  description,
  image,
  isActive
) => {
  return await axios
    .post(
      API_URL + "admin/addfashion",
      {
        title,
        url,
        category,
        description,
        image,
        isActive,
      },
      {
        headers: authHeader(),
      }
    )
    .then((response) => {
      return response.data;
    });
};

const addInnerFashion = async (
  title,
  url,
  category,
  content,
  innerImage,
  price,
  id
) => {
  return await axios
    .patch(
      API_URL + `admin/addinnerfashion/${id}`,
      {
        title,
        url,
        category,
        content,
        innerImage,
        price,
      },
      {
        headers: authHeader(),
      }
    )
    .then((response) => {
      return response.data;
    });
};

const getFashion = async () => {
  return await instance
    .get(API_URL + "admin/fashion", {
      headers: authHeader(),
    })
    .then((response) => {
      return response.data;
    });
};

const updateFashion = async (id, isActive) => {
  return await axios
    .patch(
      API_URL + `admin/updatefashion/${id}`,
      { isActive },
      {
        headers: authHeader(),
      }
    )
    .then((response) => {
      return response.data;
    });
};

const updateContent = async (id, content) => {
  return await axios
    .patch(
      API_URL + `admin/updatefashioncontent/${id}`,
      { content },
      {
        headers: authHeader(),
      }
    )
    .then((response) => {
      return response.data;
    });
};

const updateFashionData = async (
  id,
  title,
  url,
  category,
  description,
  image,
  oldImage
) => {
  return await axios
    .put(
      API_URL + `admin/updatefashion/${id}`,
      {
        title,
        url,
        category,
        description,
        image,
        oldImage,
      },
      {
        headers: authHeader(),
      }
    )
    .then((response) => {
      return response.data;
    });
};

const deleteFashion = async (id) => {
  return await axios
    .delete(API_URL + `admin/deletefashion/${id}`, {
      headers: authHeader(),
    })
    .then((response) => {
      return response.data;
    });
};

const deleteInnerFashion = async (id, fashionId, oldImage) => {
  return await axios
    .patch(
      API_URL + `admin/deleteinnerfashion/${id}`,
      {
        fashionId,
        oldImage,
      },
      {
        headers: authHeader(),
      }
    )
    .then((response) => {
      return response.data;
    });
};
const fashionService = {
  addFashion,
  addInnerFashion,
  getFashion,
  updateFashion,
  updateFashionData,
  updateContent,
  deleteFashion,
  deleteInnerFashion,
};
export default fashionService;
